import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS, Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { KnownThreadStatus } from '../../../types';

export const upsertSmsOntoThread = (thread: Thread, sms: SMS): Thread => {
  const originalSms = thread.messages[0];
  if (!originalSms) {
    return {
      ...thread,
      messages: [sms],
    };
  }

  const isDifferentSms = originalSms.id !== sms.id;
  const originalIsOlder = originalSms.createdAt < sms.createdAt;
  if (!isDifferentSms || originalIsOlder) {
    return {
      ...thread,
      messages: [sms],
      status: sms.direction === Direction.DIRECTION_INBOUND ? KnownThreadStatus.NEW : thread.status,
      actionable:
        isDifferentSms && sms.direction === Direction.DIRECTION_OUTBOUND && !sms.autogeneratedBy
          ? false
          : thread.actionable,
    };
  }

  return thread;
};
